import api from "@/config/http-client-gateway";
import { showErrorToast } from '@/kernel/alerts';
import { getRoleByToken } from "@/kernel/utils";
import { getToken } from "@/kernel/utils";


export const uploadFile = async (fileData) => {
  try {
    const response = await api.doPostFormData('/upload_php.php', fileData);
    return response?.data;
  } catch (error) {
    console.log('Error uploading file:', error);
    showErrorToast('Error subiendo el archivo, tamaño máximo 150kb');
  }
}

export const updateFileService = async (fileData) => {
  try {
    const response = await api.doPutFormData('/files', fileData);
    return response?.data;
  } catch (error) {
    console.error('Error updating file:', error);
    showErrorToast('Error actualizando el archivo, tamaño máximo 150kb');
  }
}

export const getFiles = async (params) => {
  try {
    const role = await getRoleByToken();
    let url = '/files';
    if (role === 'INVESTORS') {
      url = '/files/investor';
    }
    const response = await api.doGet(url, {params});
    return response?.data;
  } catch (error) {
    console.log('Error fetching files:', error);
   if (getToken()) {
      showErrorToast('Error obteniendo los archivos');
    }
  }
};

export const deleteFileService = async (fileId) => {
  try {
    const response = await api.doDelete(`/files`, { id: fileId });
    return response?.data;
  } catch (error) {
    console.log('Error deleting file:', error);
    showErrorToast('Error eliminando el archivo');
  }
}